module.exports = __webpack_public_path__ + "f455bd75cd32357f3c560b7efab342a6.svg";